var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 40C0 17.9086 17.9086 0 40 0C62.0914 0 80 17.9086 80 40C80 62.0914 62.0914 80 40 80C17.9086 80 0 62.0914 0 40Z",
    fill: "#C6A75E",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6668 55V51.6667C46.6668 49.8986 45.9645 48.2029 44.7142 46.9526C43.464 45.7024 41.7683 45 40.0002 45H30.0002C28.2321 45 26.5364 45.7024 25.2861 46.9526C24.0359 48.2029 23.3335 49.8986 23.3335 51.6667V55",
    stroke: "#C6A75E",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0002 38.3333C38.6821 38.3333 41.6668 35.3486 41.6668 31.6667C41.6668 27.9848 38.6821 25 35.0002 25C31.3183 25 28.3335 27.9848 28.3335 31.6667C28.3335 35.3486 31.3183 38.3333 35.0002 38.3333Z",
    stroke: "#C6A75E",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6665 54.9999V51.6666C56.6654 50.1894 56.1738 48.7545 55.2688 47.5871C54.3638 46.4196 53.0967 45.5858 51.6665 45.2166",
    stroke: "#C6A75E",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6665 25.2166C48.1005 25.5837 49.3716 26.4177 50.2792 27.5871C51.1869 28.7564 51.6796 30.1946 51.6796 31.6749C51.6796 33.1552 51.1869 34.5934 50.2792 35.7627C49.3716 36.9321 48.1005 37.7661 46.6665 38.1332",
    stroke: "#C6A75E",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon 4.487180f0077273a9ccdde3689d978e9a.svg";
export { ForwardRef as ReactComponent };